<template>
  <router-view />
</template>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: rgba(0, 0, 0, 0.8);
}

* {
  box-sizing: border-box;
}
html,
body {
  padding: 0;
  margin: 0;
  overflow: hidden;
  width: 100%;
  height: 100%;
}

:root {
  --tab-group-second-font-size: 12px; /*列表单元格两行内容的第二行字体大小*/
}

ul {
  padding: 0;
  margin: 0;
}

li {
  list-style: none;
}

.overflow-y {
  overflow-y: auto;
}

.flex {
  display: flex;
}

.flex-column {
  display: flex;
  flex-direction: column;
}

.align-center {
  align-items: center;
}

.just-center {
  justify-content: center;
}

.padding10 {
  padding: 10px;
}

/* #region 数字文本框取消上下箭头 */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}
/* #endregion */

/*滚动条样式 */
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background-color: #61b0f5;
}

::-webkit-scrollbar-track {
  border-radius: 8px;
  background-color: transparent;
}

.c-list-box {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 10px;

  & > .c-list-nav {
    display: flex;

    & > .c-list-title {
      flex: 1;
      font-weight: 600;
      font-size: 14px;
      color: rgb(60, 60, 60);
    }
  }

  & > .c-list-search {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    border: 1px solid var(--el-border-color-lighter);
    padding: 10px;
    border-bottom: 0;
    margin-top: 10px;
    align-items: center;
  }

  & > .c-list-table {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;
  }
}

/*表格滚动条样式 */
.el-table {
  .el-scrollbar__thumb {
    opacity: 1;
    background-color: #61b0f5 !important;
  }

  .el-scrollbar__bar.is-vertical {
    width: 10px;
  }

  .el-scrollbar__bar.is-horizontal {
    display: block !important;
    height: 10px;
  }

  .el-table__header {
    .el-table__cell {
      .cell {
        white-space: nowrap;
        text-overflow: unset;

        .caret-wrapper {
          width: fit-content;

          .sort-caret {
            left: 1px;
          }
        }
      }
    }
  }
  /* .el-table__body {
    .el-table__cell {
      .cell {
        line-height: 18px;
      }
    }
  } */
}

.list-box {
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding: 10px;
  display: flex;
  flex-direction: column;

  & > .list-search {
    display: flex;
    border: 1px solid var(--el-border-color-lighter);
    padding: 10px;
    border-bottom: 0;
  }

  & > .list-table {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;
  }
}

.tree-box {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;

  & > .tree-box-tree {
    width: 300px;
    display: flex;
    flex-direction: column;
    border-right: 0;
    padding-right: 10px;

    & > ul:first-child {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #f6f6f6;
      padding-bottom: 10px;
      margin-bottom: 5px;
    }
  }

  & > .tree-box-content {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;

    & > .tree-box-content-search {
      display: flex;
      border: 1px solid var(--el-border-color-lighter);
      padding: 10px;
      border-bottom: 0;
    }

    & > .tree-box-content-table {
      display: flex;
      flex-direction: column;
      flex: 1;
      overflow: hidden;
    }
  }
}

.tabCss {
  border-left: 1px solid var(--el-table-border-color) !important;
  border-top: 1px solid var(--el-table-border-color) !important;
  border-right: 1px solid var(--el-table-border-color) !important;
}

/*弹窗页面样式 */
.popup-box {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  & > .form-box {
    flex: 1;
    overflow-y: auto;
    padding: 20px;
  }

  & > .html25W {
    .el-select,
    .el-input,
    .el-textarea {
      width: 25%;
    }
  }

  & > .html30W {
    .el-select,
    .el-input,
    .el-textarea {
      width: 30%;
    }
  }

  & > .html50W {
    .el-select,
    .el-input,
    .el-textarea {
      width: 50%;
    }
  }

  & > .submit-box {
    height: 50px;
    box-shadow: 0 -3px 5px 1px #e2e2e2;
    display: flex;
    align-items: center;
    padding: 10px;
  }
}

.desc-box {
  & .el-form-item {
    margin-bottom: 0 !important;
  }

  .el-select,
  .el-input,
  .el-input-number,
  .el-textarea {
    width: 15vw;
  }

  & td:nth-child(2n + 1) {
    width: 8vw;
    white-space: nowrap;
  }

  .el-descriptions__content {
    & > div {
      width: 200px;
    }
  }
}

.desc-item-label {
  width: 150px;
}

.form-horizontal {
  display: flex;

  & > .el-form-item {
    flex: 1;
  }
}

/*树结构组件右键菜单 */
.tree_rightmenu {
  position: fixed;
  box-shadow: 0 0 12px 2px rgba(0, 0, 0, 0.175);
  z-index: 1000;
  border-radius: 5px;
}

/**页面详情的选项卡样式 */
.detail-tabs {
  & > .el-tabs__header {
    margin: 0;
  }

  & .el-tabs__content {
    position: inherit !important;
  }
}

.number-input-left {
  .el-input__inner {
    text-align: left !important;
  }
}

.number-input-suffix {
  position: relative;

  &::after {
    content: attr(suffix);
    border-left: var(--el-border);
    display: flex;
    align-items: center;
    font-size: 12px;
    background-color: #f5f7fa;
    padding: 0 10px;
    position: absolute;
    right: 1px;
    top: 1px;
    height: calc(100% - 2px);
    color: var(--el-color-info);
    border-top-right-radius: var(--el-border-radius-base);
    border-bottom-right-radius: var(--el-border-radius-base);
  }

  .el-input__wrapper {
    padding-right: 44px !important;
    padding-left: 10px !important;
  }
}

/*添加页form表单格式 */
.infoForm {
  max-width: 40%;

  .el-form-item {
    display: flex;
    align-items: center;

    .el-select,
    .el-input,
    .el-input-number {
      flex: 1;
    }
  }
}

.input-loading {
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99;
  }
  &::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    width: 0;
    height: 0;
    margin: auto;
    border-radius: 50%;
    background-color: #1e90ff;
    animation: 1s input-loading-animation infinite linear;
  }
}

@keyframes input-loading-animation {
  from {
    width: 0;
    height: 0;
    opacity: 1;
  }

  to {
    width: 40px;
    height: 40px;
    opacity: 0;
  }
}

.el-message-box__message {
  overflow: hidden;
}

.custom-select {
  .el-select-dropdown__item {
    height: auto !important;
    line-height: normal;
  }
}

/*颜色 */
.color-green {
  color: #080 !important;
}

.color-red {
  color: #f00 !important;
}

/*详情页选项卡样式 */
.detail-tabs {
  .el-tabs__content {
    position: inherit;
    flex: 1;
    display: flex;

    & > div {
      width: 100%;
    }
  }
}

/**添加页表格 */
.cus-desc {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
  background-color: #f6f6f6;
  padding: 10px;

  .el-form-item {
    width: 33.33%;
    display: flex;
    align-items: center;
    height: 100px;

    .el-form-item__content {
      & > .el-select,
      & > .el-input,
      & > .el-input-number {
        width: 80%;
      }
    }
  }

  /* & > li:first-child {
      height: 100%;
      width: 150px;
      background: #f5f7fa;
      font-weight: bold;
      font-size: 14px;
      color: #606266;
      padding: 12px 15px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }

    & > li:last-child {
      display: flex;
      flex: 1;
      padding: 12px 15px;

      .el-select,
      .el-input,
      .el-input-number,
      .el-textarea {
        width: 100%;
      }

      & .el-form-item {
        margin-bottom: 0;
        width: 100%;
      }

      & .el-form-item--large {
        margin-bottom: 0;
      }
    } */
}

.info-form {
  background-color: #f6f6f6;
  padding: 20px 0 20px 40px;
  display: flex;
  flex-wrap: wrap;

  & > .el-form-item {
    width: 33.33%;
    margin: 20px 0;
    padding-right: 40px;

    .el-form-item__label {
      font-weight: 600;
      color: rgba(0, 0, 0, 0.6);
    }
  }

  & > .el-form-item-span2 {
    width: 66.66%;
  }

  & > .el-form-item-span3 {
    width: 100%;
  }
}

/*描述列表组件标签不换行 */
.desc-label-nowrap {
  .el-descriptions__label {
    white-space: nowrap !important;
  }
}

.showTooltips-1 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}

.showTooltips-2 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tab-desc {
  border-collapse: collapse; //合并为一个单一的边框
  border-color: #dfe6ec; //边框颜色按实际自定义即可

  tr th {
    background-color: #f8f8f9; //设置表格标题背景色
    padding: 6px;
    text-align: center;
  }
  tr td {
    padding: 6px;
    text-align: center;
    height: 34px; //设置单元格最小高度}
  }
}

.text-hover-decoration {
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}

.custom-select-auto-height {
  .el-select-dropdown__item {
    height: auto;
    line-height: normal;
  }
}

/*扣缴义务人和供应商角标 */
.withholding-badge {
  text-indent: 20px;
  position: relative;

  &::before {
    content: attr(data-type);
    text-indent: 0;
    top: 3px;
    color: #fff;
    font-size: 11px;
    padding: 2px;
    line-height: 12px;
    background-color: var(--dynamic-color) !important;
    position: absolute;
    border-radius: 2px;
    left: 0;
  }
}

/**负责人下拉树组件样式 */
.belonger-tree-class {
  --el-tree-node-content-height: 40px !important;

  & .el-select-dropdown__item {
    display: flex;
    align-items: center;
    height: 40px !important;
    line-height: 40px !important;
  }
}


.withholdingagent-cascader {
  height: 32px;

  .el-input--suffix {
    height: 32px;
  }

  .el-cascader__tags {
    flex-wrap: nowrap !important;
  }
}

.c-withholdingagent-search-select {
  width: 115px !important;

  & > div {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
}

.c-withholdingagent-search-groupbox {
  width: 300px;
  align-items: center;
  display: flex;
  border-radius: var(--el-input-border-radius, var(--el-border-radius-base));
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border: var(--el-border);
  border-left: 0;
  padding: 1px 11px;
  font-size: var(--el-font-size-base);
  height: var(--el-input-height, 32px);
  cursor: pointer;

  &:hover {
    border-color: var(--el-border-color-hover) !important;
  }

  & .el-icon:hover {
    font-size: 110%;
  }

  .c-withholdingagent-search-tag {
    white-space: nowrap;
    background-color: #f0f2f5;
    color: var(--el-color-info);
    border-radius: 4px;
    font-size: 12px;
    padding: 0 9px;
    height: 24px;
    line-height: 24px;
  }
}

.c-withholdingagent-search-box {
  width: 300px;
  align-items: center;
  display: flex;
  border-radius: var(--el-input-border-radius, var(--el-border-radius-base));
  border: var(--el-border);
  padding: 1px 11px;
  font-size: var(--el-font-size-base);
  height: var(--el-input-height, 32px);
  cursor: pointer;

  &:hover {
    border-color: var(--el-border-color-hover) !important;
  }

  & .el-icon:hover {
    font-size: 110%;
  }

  .c-withholdingagent-search-tag {
    white-space: nowrap;
    background-color: #f0f2f5;
    color: var(--el-color-info);
    border-radius: 4px;
    font-size: 12px;
    padding: 0 9px;
    height: 24px;
    line-height: 24px;
  }
}
</style>
